import React, { useCallback, useContext, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { ParentScreenCtx } from "/src/pages/workbench_build/WorkbenchBuild";
import { FormControl, TextField } from "@mui/material";
import { cloneDeep, debounce } from "lodash";
import { treeActions } from "../../redux/slices/treeSlice";


export const Description = ({tab, screen})=>{
    const parentScreen = useContext(ParentScreenCtx)
    const [description,setDescription] = useState('');
    const {leftTree,rightTree} = useSelector(state=>state.treeData[parentScreen])
    const templateHeader = rightTree.tree.templateHeader;
    const dispatch = useDispatch();

    useEffect(() => {
      if (screen && screen === "workflow") {
        setDescription(templateHeader?.WORKFLOW?.COMMENTS ? (templateHeader?.WORKFLOW?.COMMENTS)  : "");
      } else
        setDescription((templateHeader?.NOTES || ""));
    }, [templateHeader]);


    const changeHandler =(e)=>{
        const {value } =e.target;
        setDescription(value);
        debounceChangeHandler(value);
    }

    const sumbitChange = (value)=>{
        if(screen && screen === 'workflow'){
            let modifiedTemplateHeader = cloneDeep(templateHeader);
            modifiedTemplateHeader.WORKFLOW.COMMENTS = (value)
            
            dispatch(treeActions.setRightTreeTemplateHeader({
                value: modifiedTemplateHeader,
                screen: parentScreen
            }))
        } else dispatch(treeActions.setRightTreeTemplateHeaders({screen: parentScreen, key: "NOTES", value: (value)}));
    }

    const debounceChangeHandler = useCallback(debounce(sumbitChange, 100), [
        rightTree.tree,
        rightTree.currentTab
      ]);


    return(
        <div className="height-100" style={{padding: '24px 5px'}}>
            <FormControl
                className="width-100 height-100"
                size="small"
                sx={{height: '100%', overflow:'hidden'}}
                id="templatePropertiesDescription"
            >
                <TextField
                    className="text-field-scroll width-100"
                    multiline={true}
                    size="medium"
                    type="text"
                    sx={{
                        width:'95%',
                        margin:'auto',
                        height: '100%',
                        minHeight: '100%'
                    }}
                    minRows={10}
                    value={description}
                    onChange={changeHandler}
                />
            </FormControl>
        </div>
    )

}